import { render, staticRenderFns } from "./BuildAccountsList.vue?vue&type=template&id=8278cefe&scoped=true"
import script from "./BuildAccountsList.vue?vue&type=script&lang=js"
export * from "./BuildAccountsList.vue?vue&type=script&lang=js"
import style0 from "./BuildAccountsList.vue?vue&type=style&index=0&id=8278cefe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8278cefe",
  null
  
)

export default component.exports